export default __webpack_public_path__ + "static/media/0a63298ee492ed374d4524f3318e2a66.svg";